module.exports = __webpack_public_path__ + "static/media/chevronDisabled.bc5060b8.svg";